export default function Avatar({ url }: any): JSX.Element {

    return <img src={url || "https://res-oss.lighttcm.com/download/default_user_avatar.png"} width={38} alt="" />
}